<template>
  <div class="stepWrap">
    <el-skeleton animated class="wd1000" v-if="loading" />
    <template v-else>
      <div class="flex" v-for="item in currentSteps" :key="`step-${item.currentPath}`">
        <div class="fxRow wireWrap" :class="{ stepActive: currentPathIndex >= item.idx }" v-if="item.prevPath">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="circle"></div>
        </div>
        <div class="stepItem" :class="{ 'crp stepActive': currentPathIndex >= item.idx && !again, 'crna stepActive': again }" @click="toLink(item)">
          <div class="fxRow iconWrap">
            <img :src="item.defaultImg" alt="" class="grayIcon" />
            <img :src="item.activeImg" alt="" class="blueIcon" />
          </div>
          <p class="stepTitle">{{ item.idx + 1 }}. {{ $t(item.title) }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "ApplyStep",
  data() {
    return {
      currentSteps: [], // 当前步骤列表
      currentPathIndex: 0, // 当前步骤对应的索引
      again: false, // 资料重新上传
      query: {}, // 路由参数
      loading: true,
    };
  },
  computed: {
    ...mapState("user", ["isCoordinator"]),
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["getApplyStepList"]),
  },
  watch: {
    applymentDetail: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.setApplyStep();
          this.$nextTick(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      },
    },
  },
  methods: {
    // 设置申请步骤
    setApplyStep() {
      this.currentSteps = this.getApplyStepList();
      // 设置当前选中的步骤索引
      const path = this.$route.path;
      const currentData = this.currentSteps.find(item => item.currentPath == path);
      this.currentPathIndex = currentData?.idx;

      const query = this.$route.query;
      if (query.again == 1) {
        // 当路由参数again为1时，才能重新上传资料，其他步骤禁止修改
        this.again = true;
      }
      this.query = query;
    },
    // 点击跳转
    toLink(data) {
      if (this.again) return;
      if (data.idx < this.currentPathIndex) {
        this.$router.push({
          path: data.currentPath,
          query: {
            ...this.query,
          },
        });
      }
    },
    // 返回当前步骤的索引，保存接口会用到
    getCurrentStepIndex() {
      // 为了兼容旧数据，这里需要+1
      return this.currentPathIndex + 1;
    },
    // 返回步骤列表的长度
    getStepListLength() {
      return this.currentSteps.length;
    },
    // 跳转上一步
    toPreviousStep() {
      const data = this.currentSteps[this.currentPathIndex - 1];
      this.$router.push({
        path: data.currentPath,
        query: {
          ...this.query,
        },
      });
    },
    // 跳转下一步
    toNextStep() {
      const data = this.currentSteps[this.currentPathIndex + 1];
      this.$router.push({
        path: data.currentPath,
        query: {
          ...this.query,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stepWrap {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding-top: 20px;
  height: 180px;

  .stepItem {
    .iconWrap {
      width: 74px;
      height: 74px;
      border-radius: 74px;
      background: #fff;
      margin: 0px auto;

      .blueIcon {
        display: none;
      }
    }

    .stepTitle {
      padding-top: 16px;
      font-size: 14px;
      color: #011a45;
      text-align: center;
    }
  }

  .wireWrap {
    height: 74px;
    margin: 0px 20px;

    .line {
      width: 10px;
      height: 2px;
      background: #7987a0;
      margin-right: 2px;
    }

    .circle {
      width: 6px;
      height: 6px;
      background: #7987a0;
      border-radius: 6px;
      margin-left: -8px;
    }
  }

  .stepActive {
    .grayIcon {
      display: none !important;
    }

    .blueIcon {
      display: block !important;
    }

    .stepTitle {
      color: #0060ff !important;
      font-weight: bold !important;
    }

    .line,
    .circle {
      background: #0060ff !important;
    }
  }
}

@media (max-width: 1100px) {
  /* 当屏幕宽度小于或等于 1000px 时，这里的样式会生效 */
  .stepWrap {
    .wireWrap {
      margin: 0 10px;
    }

    .stepItem {
      .stepTitle {
        font-size: 13px;
      }
    }
  }
}
</style>
